import * as React from 'react'
import type { RouteObject } from 'react-router'

const Addresses = React.lazy(() => import('../views/Addresses/Addresses'))
const InvoiceInfos = React.lazy(
    () => import('../views/InvoiceInfos/InvoiceInfos'),
)
const Invoices = React.lazy(() => import('../views/Invoices/Invoices'))

export const UserRouter: RouteObject[] = [
    {
        path: '/addresses',
        element: <Addresses />,
    },
    {
        path: '/invoice-infos',
        element: <InvoiceInfos />,
    },
    {
        path: '/invoices',
        element: <Invoices />,
    },
]
